import { Component, AfterViewInit, EventEmitter, ViewChild, Input, Output, OnDestroy } from '@angular/core';
import { ModalDirective, BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { SharedService } from '../../common/shared.service'
import { Router } from '@angular/router';
import { ISubscription } from "rxjs/Subscription";


/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Component class to Popup User Confirmation Dialog.  
 **/
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements AfterViewInit, OnDestroy {
    public message: string;
    @ViewChild('staticModal') public staticModal:ModalDirective;
    @Input() title?:string;
    @Input() content?:string;
    @Input() content2?:string;
    @Input() link?:string;
    @Input() state?:string;
    @Input() email?:string;
    @Input() isRegister?:string;
    @Input() isErrMsg?:string;
    @Input() isReset?:string;
    @Input() mailId?:string;
    @Output()
    resetMethod:EventEmitter<string> = new EventEmitter();
    
    modalRef: BsModalRef;
    private subscriptionFontType: ISubscription;
    public fontType: string = 'Arial';
    private subscriptionFontSize: ISubscription;
  
    public fontSize: any = {
      "sizeS" : "14px",
      "sizeM" : "19px",
      "sizeL" : "23px",
      "no_styles" : "0.9em"
    };
    
    constructor(private sharedService: SharedService, private modalService: BsModalService, private router:Router) {

      this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
        this.fontSize = data;
        $('span').css('font-size', this.fontSize.sizeS)      
      });
  
      this.subscriptionFontType = this.sharedService.fontTypeData.subscribe((data)=>{
        this.fontType = data;
        $('.mat-input-placeholder').css('font-family', this.fontType);
      });

    }

    ngAfterViewInit() {
      this.sharedService.loadFontSizeData();
      this.sharedService.loadFontTypeData();
    }

    ngOnDestroy() {
      this.subscriptionFontSize.unsubscribe();
      this.subscriptionFontType.unsubscribe();
    }

    show(){
      this.staticModal.show();
    }

    hide(){
      this.staticModal.hide();
      if (localStorage.getItem('registerinfo')) {
        localStorage.setItem('registerinfo',null);
      } 
    }

    confirm(data){
      this.router.navigate([data]);
    };

    onSubmit() {
      this.resetMethod.emit('complete');
      this.staticModal.hide();
    }

    // resetForm(data){
    //   this.router.navigate([data]);
    // }

  
}


// WEBPACK FOOTER //
// ./src/app/dialogs/confirm-dialog/confirm-dialog.component.ts